var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        "max-width": "1300",
        width: "1300",
        persistent: "",
      },
      on: {
        "click:outside": function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "v-card",
        { attrs: { tile: "", flat: "" } },
        [
          _c(
            "v-card-title",
            { staticClass: "px-5 pt-4" },
            [
              _vm._v(" Promo Item Groups "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.selected.length === 0,
                  },
                  on: { click: _vm.addGroups },
                },
                [_vm._v(" Add ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-container",
            { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.tableHeaders,
                  items: _vm.promoItemGroups,
                  dense: "",
                  height: _vm.tableHeight,
                  "group-by": "promo_item_group.id",
                  "fixed-header": "",
                  loading: _vm.loading,
                  "items-per-page": -1,
                  "custom-sort": _vm.customSort,
                  "footer-props": { "items-per-page-options": [-1] },
                  "loading-text": "Searching Available Data...Please Wait",
                  "loader-height": "5",
                  "no-data-text": "No Data to Display",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `header.select-all`,
                      fn: function () {
                        return [
                          _c("v-checkbox", {
                            staticClass: "my-auto mx-0",
                            attrs: {
                              "hide-details": "",
                              dark: "",
                              disabled: _vm.availableGroupIds.length === 0,
                              ripple: false,
                            },
                            on: { change: _vm.selectAll },
                            model: {
                              value: _vm.allSelected,
                              callback: function ($$v) {
                                _vm.allSelected = $$v
                              },
                              expression: "allSelected",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: `group.header`,
                      fn: function ({ items, headers }) {
                        return [
                          _c(
                            "td",
                            { attrs: { colspan: headers.length } },
                            [
                              _c(
                                "v-row",
                                { attrs: { align: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _vm.featureGroupIds.some(
                                        (id) =>
                                          id === items[0].promo_item_group.id
                                      )
                                        ? _c(
                                            "v-icon",
                                            { attrs: { color: "success" } },
                                            [_vm._v(" mdi-check ")]
                                          )
                                        : [
                                            _c("v-checkbox", {
                                              staticClass: "my-auto mx-0",
                                              attrs: {
                                                value:
                                                  items[0].promo_item_group.id,
                                                color: "primary",
                                                "hide-details": "",
                                                ripple: false,
                                              },
                                              model: {
                                                value: _vm.selected,
                                                callback: function ($$v) {
                                                  _vm.selected = $$v
                                                },
                                                expression: "selected",
                                              },
                                            }),
                                          ],
                                    ],
                                    2
                                  ),
                                  _c("v-col", { staticClass: "truncate" }, [
                                    _c("span", [
                                      _c("b", [_vm._v("Promo Item Group")]),
                                      _c("br"),
                                    ]),
                                    items[0].promo_item_group.name
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                items[0].promo_item_group.name
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _c("span", [_vm._v("N/A")]),
                                  ]),
                                  _c("v-col", { staticClass: "truncate" }, [
                                    _c("span", [
                                      _c("b", [_vm._v("Promo Name")]),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.selectedPromo.name) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("v-col", [
                                    _c("span", [
                                      _c("b", [_vm._v("Promo Category")]),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedPromo
                                              .promo_category_name
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("v-col", [
                                    _c("span", [
                                      _c("b", [_vm._v("Promo Start Date")]),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDateDisplay(
                                              _vm.selectedPromo.start_dt
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("v-col", [
                                    _c("span", [
                                      _c("b", [_vm._v("Promo End Date")]),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDateDisplay(
                                              _vm.selectedPromo.end_dt
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("v-col", [
                                    _c("span", [
                                      _c("b", [_vm._v("Billing Mode")]),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedPromo.billing_mode_name
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.promotion_price`,
                      fn: function ({ item }) {
                        return [
                          item.promo_item_group.promotion_price
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.promo_item_group.promotion_price
                                      )
                                    )
                                ),
                              ])
                            : _vm.selectedPromo.promotion_price
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        _vm.selectedPromo.promotion_price
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.rebate_amount`,
                      fn: function ({ item }) {
                        return [
                          item.promo_item_group.rebate_amount
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.promo_item_group.rebate_amount
                                      )
                                    )
                                ),
                              ])
                            : _vm.selectedPromo.rebate_amount
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        _vm.selectedPromo.rebate_amount
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.billback_allowance`,
                      fn: function ({ item }) {
                        return [
                          item.accrual_amt
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.accrual_amt
                                      )
                                    )
                                ),
                              ])
                            : item.promo_item_group.billback_allowance
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.promo_item_group.billback_allowance
                                      )
                                    )
                                ),
                              ])
                            : _vm.selectedPromo.billback_allowance
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        _vm.selectedPromo.billback_allowance
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.amap_allowance`,
                      fn: function ({ item }) {
                        return [
                          item.promo_item_group.amap_allowance
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.promo_item_group.amap_allowance
                                      )
                                    )
                                ),
                              ])
                            : _vm.selectedPromo.amap_allowance
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        _vm.selectedPromo.amap_allowance
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.early_buy_allowance`,
                      fn: function ({ item }) {
                        return [
                          item.promo_item_group.early_buy_allowance
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.promo_item_group
                                          .early_buy_allowance
                                      )
                                    )
                                ),
                              ])
                            : _vm.selectedPromo.early_buy_allowance
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        _vm.selectedPromo.early_buy_allowance
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.item.sale_price`,
                      fn: function ({ item }) {
                        return [
                          item.item.sale_price
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.item.sale_price
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.item.cost`,
                      fn: function ({ item }) {
                        return [
                          item.item.cost
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(item.item.cost)
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.item.unit_cost`,
                      fn: function ({ item }) {
                        return [
                          item.item.qty_per_case
                            ? _c("span", [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        _vm.calcUnitCost(item)
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _c("span", [_vm._v(" - ")]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }